import BaseConfig from "./BaseConfig";

export default class ContactEmail extends BaseConfig {
  label() {
    return (
      this.customerInfo?.supportEmail || this.toAddressMap[this.commodityType]
    );
  }
}
